import * as React from 'react'
import I18n from '../../../../core/i18n'
import { agentService } from '../../../../core/services'
import { InputText } from '../../../atoms'
import AgentLayoutNew from '../_layouts/new'
import * as interfaces from '../../../../static/interfaces'

declare var window: interfaces.IWindow

const FIELDS = {
  name: 'name',
  label: 'label',
  position: 'position',
}

const title = I18n.t('admin.create_new', {
  model: I18n.t('task', { scope: 'activerecord.models' }),
})

const AgentSkillsNew: React.FC<{}> = props => {
  const handleSubmit = React.useCallback(async (initialValues, values) => {
    const { createdTask, flush } = await agentService.createTask(values)
    window.flashMessages.addMessage({ text: flush.message, type: flush.type })
    location.href = '/agent/tasks'
  }, [])

  return (
    <AgentLayoutNew
      model="skills"
      title={title}
      fields={FIELDS}
      indexLink="/agent/tasks"
      formItems={
        <>
          <InputText required={true} name="name" defaultValue="" label={I18n.t('generic.name')} />
          <InputText
            required={true}
            name="label"
            defaultValue=""
            label={I18n.t('generic.label')}
            placeholder="メ、ホ、他、などの省略表記"
          />
          <InputText
            required={true}
            name="position"
            defaultValue=""
            label={I18n.t('generic.position')}
          />
        </>
      }
      handleSubmit={handleSubmit}
    />
  )
}

export default AgentSkillsNew
